<template>
    <div
    ref="modalEliminar"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    >
        <div
        class="modal-dialog modal-dialog-centered"
        :class="tamano ? tamano : ''"
        role="document"
        >
            <div class="modal-content">
                <div class="modal-header mb-1 border-bottom">
                    <div class="col-auto text-black f-600 f-17">
                        {{ titulo }}
                    </div>
                    <div class="ml-auto my-auto d-middle-center bg-white rounded-circle" style="width:20px;height:20px;">
                        <i class="icon-cancel-circled-outline f-20 cr-pointer text-black" data-dismiss="modal" />
                    </div>
                </div>
                <div class="modal-body overflow-auto custom-scroll" style="max-height:70vh;">
                    <div class="container">
                        <div class="row my-3 text-general f-14 justify-center text-center px-3">
                            {{ mensaje }}
                        </div>
                        <div class="row mx-0 bg-linea" />
                    </div>
                </div>
                <div class="row mx-0 justify-center pb-3">
                    <button
                    type="button"
                    class="btn-cerrar mr-2"
                    @click="cancelar"
                    v-text="textosBotones.cerrar"
                    />
                    <button
                    v-loading="cargando"
                    type="button"
                    class="btn-eliminar ml-2"
                    @click="actionEliminar"
                    v-text="textoEliminar"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        titulo: {
            type: String,
            default: ''
        },
        cargando: {
            type: Boolean,
            default: false
        },
        mensaje: {
            type: String,
            default: ''
        },
        tamano: {
            type: String,
            default: ''
        },
        textoEliminar: {
            type: String,
            default: 'Eliminar'
        }
    },
    data(){
        return {
            textosBotones: {
                eliminar: 'Eliminar',
                cerrar: 'Cerrar'
            }
        }
    },
    methods: {
        toggle(){
            $(this.$refs.modalEliminar).modal('toggle')
        },
        guardar(){
            this.$emit('guardar')
        },
        actionEliminar(){
            this.$emit('eliminar')
            this.toggle()

        },
        onAdicional(){
            this.$emit('adicional')
        },
        cancelar(){
            this.$emit('cancelar')
            this.toggle()
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~/assets/sass/app.scss';

.bg-linea{
    background: linear-gradient(to right, #fff, #D1D1D1, #fff);
    height: 1px;
}
.modal-content{
    border: none;
    border-radius: 8px;
    .modal-header{
        height: 60px;
        background-color: #F6F9FB;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-bottom: none;
        background-size: cover;
        .close{
            outline: none;
            transition-duration: .85s;
            position: absolute;
            right: 10px;
            top: 1px;
            font-size: 2.5em;
            &:hover{
                transition-duration: .4s;
                transform: rotate(360deg) scale(1.2);
            }
        }
        .logo{
            display: block;
            // height: 70px;
            // width: 70px;
            span{
                font-size: 1.2em;
            }
        }
    }
    .modal-title{
        color: $azul2-primary;
        font-weight: normal;
    }
}
.img-tipo{
    position: absolute;
    top:20px;
    left: 50%;
    transform: translate(-50%);
}
</style>
